export default __webpack_public_path__ + "static/Plots0083-81bb4e9e1def6c9054b61b302e5d0ee6.jpg";